"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormControlOverrides = void 0;
var createMuiFormControlOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        marginNormal: {
            marginTop: spacing(0),
            marginBottom: spacing(4),
        },
    });
};
exports.createMuiFormControlOverrides = createMuiFormControlOverrides;
//# sourceMappingURL=MuiFormControl.js.map